import { waitForAllReturnWhenError } from '@confluence/query-preloader-tools/entry-points/waitForAllReturnWhenError.ts';
import { query } from '@confluence/query-preloader-tools/entry-points/graphql.ts';
import { preloadFeatureDiscovery } from '@confluence/feature-discovery/entry-points/preloadFeatureDiscovery.ts';

import { NTH_USER_AUTO_FOLLOW_SPACES } from '../../constants/onboarding-state/onboarding-constants.ts';

import onboardingStateGetOnboardingStateQuery from './__generated__/onboardingStateGetOnboardingStateQuery.graphql.ts';
import type { GraphQLErrorPayload as GraphQLErrorInterop } from '@confluence/relay-errors/entry-points/RelayError.ts';

export const preloadAutoFollowSpacesState = (): Promise<
	| void
	| Error[]
	| {
			data: unknown;
			errors?: ReadonlyArray<GraphQLErrorInterop>;
			hasErrors: boolean;
	  }[]
> => {
	return waitForAllReturnWhenError([
		query({
			query: onboardingStateGetOnboardingStateQuery,
			variables: {
				key: NTH_USER_AUTO_FOLLOW_SPACES.HAS_AUTO_FOLLOWED_SPACES,
			},
		}),
		preloadFeatureDiscovery(),
	]);
};
